import { render, staticRenderFns } from "./WarehouseReceptions.vue?vue&type=template&id=966205de&lang=pug&"
import script from "./WarehouseReceptions.vue?vue&type=script&lang=js&"
export * from "./WarehouseReceptions.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseReceptions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports